import { inject, observer } from 'mobx-react';
import { getRoot } from 'mobx-state-tree';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { modelOf } from '../../prop-types';
import ConfigStore from '../../store/ConfigStore';
import GoogleAnalyticsGTM from './GoogleAnalyticsGTM';

const GoogleTagManager = ({ configStore }) => {
  useEffect(() => {
    const rootStore = getRoot(configStore);

    const gtm = new GoogleAnalyticsGTM(rootStore);

    gtm.setup();
  }, []);

  return (
    <>
      <Helmet>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              originalLocation: document.location.protocol + '//' +
              document.location.hostname +
              document.location.pathname +
              document.location.search
            });
            `}
        </script>
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[1],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${configStore.gtm.containerId}');`}
        </script>
      </Helmet>
      <noscript>
        <iframe
          title="GTM"
          src={`https://www.googletagmanager.com/ns.html?id=${configStore.gtm.containerId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
};

GoogleTagManager.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
};

export default inject('configStore')(observer(GoogleTagManager));
